module.exports = __webpack_public_path__ + "img/681.fa1bf208.png";